/**
 * ツールチップの表示制御を初期化する
 */
// ツールチップ(クリック)
$(function(){
	/**
	 * ツールチップボタンクリック時にツールチップを表示する
	 */
	$(".js-tooltip-btn").click(function(){
		$('.js-tooltip-box').hide();
		$(this).next("div").show();
		/**
		 * ツールチップ閉じるボタンクリック時にツールチップを非表示にする
		 */
		$('.js-tooltip-close').click(function(){
			$(this).parents('.js-tooltip-box').hide();
		});
	});
	/**
	 * HTML要素マウスダウン時にツールチップを非表示にする
	 */
	 // 表示されたツールチップを隠す
	$('html').on('mousedown', function(event){
		$('.js-tooltip-box').hide();
	});
	/**
	 * ツールチップ内のマウスダウンイベントの伝播を停止する
	 */
	$('.js-tooltip-box,.js-tooltip-btn').on('mousedown', function(event){
		event.stopPropagation();
	});	
	return false;
});
